<template>
  <div class="pt-4">
    <gg-card>
      <gg-card-header>
        Change Security Questions
      </gg-card-header>
      <gg-card-text>
        <gg-loading :loading="!questionsLoaded">
          <edit-questions v-if="!isSaved"
                          :questions="questionsList"
                          :loading="loading"
                          @save="saveAnswers"
          />
          <saved-questions v-else
                           :questions="savedQuestions"
                           @change="changeQuestions"
          />
        </gg-loading>
      </gg-card-text>
    </gg-card>
  </div>
</template>

<script>
import EditQuestions from 'Components/Profile/Security/SecurityQuestions/EditQuestions'
import SavedQuestions from 'Components/Profile/Security/SecurityQuestions/SavedQuestions'
import { mapActions } from 'vuex'

export default {
  name: 'SecurityQuestions',
  components: {
    EditQuestions,
    SavedQuestions
  },
  data () {
    return {
      questionsList: [],
      savedQuestions: [],
      loading: false,
      questionsLoaded: false,
    }
  },
  computed: {
    // questionsListA () {
    //   return this.questionsList.filter(x => {
    //     if (x !== this.model.sq_B) {
    //       return x
    //     }
    //   })
    // },
    // questionsListB () {
    //   return this.questionsList.filter(x => {
    //     if (x !== this.model.sq_A) {
    //       return x
    //     }
    //   })
    // },
    isSaved () {
      return this.savedQuestions.length !== 0
    }
  },
  methods: {
    ...mapActions(['getSqList', 'saveSqAnswers', 'reportSuccess', 'reportError']),
    async getQuestions () {
      try {
        const { available, saved } = await this.getSqList()

        this.questionsList = available
        this.savedQuestions = saved
        this.questionsLoaded = true
      } catch (e) {
        this.reportError(e)
      }
    },
    async saveAnswers (data) {
      try {
        this.loading = true

        await this.saveSqAnswers(data)
        await this.getQuestions()

        this.reportSuccess('Security answers updated.')
        this.loading = false
      } catch (e) {
        this.loading = false
        this.reportError(e)
      }
    },
    changeQuestions () {
      this.savedQuestions = []
    },
  },
  mounted () {
    this.getQuestions()
  },
}
</script>
